import React, { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import useLocalStorage from "../hooks/useLocalStorage";

const DEFAULT_SETTINGS = {
  speechEnabled: false,
  language: "en",
  onlyIsideMessage: true,
  advancedMessaging: false,
  aistype: 12,
  aisStatus: false,
  //mapServerUrl: `${window.location.protocol}//${window.location.hostname}:8080`,
  mapServerUrl: "https://isidemaps.m3s.it",
  sendDummyPosition: false,
};

const SettingsContext = React.createContext();

export function useSettings() {
  return useContext(SettingsContext);
}

export function SettingsProvider({ children }) {
  const { i18n } = useTranslation();
  const [settings, setSettings] = useLocalStorage("settings", {
    ...DEFAULT_SETTINGS,
  });

  useEffect(() => {
    if (settings == null) return;
    if (
      settings["language"] != null &&
      settings["language"] !== i18n.language
    ) {
      // console.log(`Setting app language to: ${settings["language"]}`);
      i18n.changeLanguage(settings["language"]);
    }
  }, [settings, i18n]);

  const updateSettings = (key, value) => {
    if (settings[key] !== value) {
      setSettings((prevSettings) => {
        return { ...prevSettings, [key]: value };
      });
    }
  };

  const updateMapServerUrl = (value) => {
    updateSettings(
      "mapServerUrl",
      value ? value : DEFAULT_SETTINGS["mapServerUrl"]
    );
  };

  const value = {
    speechEnabled: settings["speechEnabled"],
    setSpeechEnabled: (value) => updateSettings("speechEnabled", value),
    language: settings["language"],
    setLanguage: (value) => updateSettings("language", value),
    onlyIsideMessage: settings["onlyIsideMessage"],
    setOnlyIsideMessage: (value) => updateSettings("onlyIsideMessage", value),
    advancedMessaging: settings["advancedMessaging"],
    setAdvancedMessaging: (value) => updateSettings("advancedMessaging", value),
    aistype: settings["aistype"],
    setAistype: (value) => updateSettings("aistype", value),
    supportedAistypes: [6, 12],
    aisStatus: settings["aisStatus"],
    setAisStatus: (value) => updateSettings("aisStatus", value),
    mapServerUrl: settings["mapServerUrl"],
    setMapServerUrl: (value) => updateMapServerUrl(value),
    sendDummyPosition: settings["sendDummyPosition"],
    setSendDummyPosition: (value) => updateSettings("sendDummyPosition", value),
    resetSettings: () => setSettings({ ...DEFAULT_SETTINGS }),
  };

  return (
    <SettingsContext.Provider value={value}>
      {children}
    </SettingsContext.Provider>
  );
}
